/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type MutationResult = "failure" | "skipped" | "success" | "%future added value";
export type NeedStatus = "has" | "needs" | "obtained" | "unknown" | "%future added value";
export type RecidivismReason = "civil" | "new_charge" | "unknown" | "%future added value";
export type YesNoUnknown = "no" | "unknown" | "yes" | "%future added value";
export type IdInput = {
    readonly id: string;
};
export type caseUpdateMutationVariables = {
    readonly case_id: string;
    readonly supervision_start_date?: string | null;
    readonly supervision_end_date?: string | null;
    readonly housing?: NeedStatus | null;
    readonly employment?: NeedStatus | null;
    readonly education?: NeedStatus | null;
    readonly transportation?: NeedStatus | null;
    readonly did_recidivate?: YesNoUnknown | null;
    readonly case_type?: string | null;
    readonly medicated?: YesNoUnknown | null;
    readonly program_result?: string | null;
    readonly risk_level?: string | null;
    readonly assessment_score?: string | null;
    readonly recidivism_reason?: RecidivismReason | null;
    readonly primary_treatment_facilities?: ReadonlyArray<IdInput | null> | null;
    readonly hand_off_to_probation?: YesNoUnknown | null;
    readonly treatment_types?: ReadonlyArray<IdInput | null> | null;
    readonly courts?: ReadonlyArray<IdInput | null> | null;
    readonly group_meetings?: ReadonlyArray<IdInput | null> | null;
    readonly absconded?: YesNoUnknown | null;
    readonly is_emh?: YesNoUnknown | null;
    readonly risk_score?: string | null;
};
export type caseUpdateMutationResponse = {
    readonly updateCase: ({
        readonly case: ({
            readonly id: string;
            readonly case_number: string;
            readonly supervision_start_date: string | null;
            readonly supervision_end_date: string | null;
            readonly created_at: string;
            readonly updated_at: string | null;
            readonly housing: ({
                readonly status: NeedStatus | null;
            }) | null;
            readonly employment: ({
                readonly status: NeedStatus | null;
            }) | null;
            readonly education: ({
                readonly status: NeedStatus | null;
            }) | null;
            readonly treatment_types: ReadonlyArray<({
                readonly id: string;
            }) | null> | null;
            readonly group_meetings: ReadonlyArray<({
                readonly id: string;
            }) | null> | null;
            readonly courts: ReadonlyArray<({
                readonly id: string;
            }) | null> | null;
            readonly transportation: ({
                readonly status: NeedStatus | null;
            }) | null;
            readonly primary_treatment_facilities: ReadonlyArray<({
                readonly id: string;
            }) | null> | null;
            readonly did_recidivate: YesNoUnknown | null;
            readonly recidivism_reason: RecidivismReason | null;
            readonly case_type: string | null;
            readonly medicated: YesNoUnknown | null;
            readonly program_result: string | null;
            readonly risk_level: string | null;
            readonly assessment_score: string | null;
            readonly hand_off_to_probation: YesNoUnknown | null;
            readonly absconded: YesNoUnknown | null;
            readonly is_emh: YesNoUnknown | null;
            readonly risk_score: string | null;
        }) | null;
        readonly result: MutationResult;
    }) | null;
};
export type caseUpdateMutation = {
    readonly response: caseUpdateMutationResponse;
    readonly variables: caseUpdateMutationVariables;
};



/*
mutation caseUpdateMutation(
  $case_id: String!
  $supervision_start_date: String
  $supervision_end_date: String
  $housing: NeedStatus
  $employment: NeedStatus
  $education: NeedStatus
  $transportation: NeedStatus
  $did_recidivate: YesNoUnknown
  $case_type: String
  $medicated: YesNoUnknown
  $program_result: String
  $risk_level: String
  $assessment_score: String
  $recidivism_reason: RecidivismReason
  $primary_treatment_facilities: [IdInput]
  $hand_off_to_probation: YesNoUnknown
  $treatment_types: [IdInput]
  $courts: [IdInput]
  $group_meetings: [IdInput]
  $absconded: YesNoUnknown
  $is_emh: YesNoUnknown
  $risk_score: String
) {
  updateCase(case_id: $case_id, supervision_start_date: $supervision_start_date, supervision_end_date: $supervision_end_date, housing: $housing, employment: $employment, education: $education, transportation: $transportation, did_recidivate: $did_recidivate, treatment_types: $treatment_types, case_type: $case_type, medicated: $medicated, program_result: $program_result, courts: $courts, risk_level: $risk_level, assessment_score: $assessment_score, recidivism_reason: $recidivism_reason, primary_treatment_facilities: $primary_treatment_facilities, hand_off_to_probation: $hand_off_to_probation, group_meetings: $group_meetings, absconded: $absconded, is_emh: $is_emh, risk_score: $risk_score) {
    case {
      id
      case_number
      supervision_start_date
      supervision_end_date
      created_at
      updated_at
      housing {
        status
      }
      employment {
        status
      }
      education {
        status
      }
      treatment_types {
        id
      }
      group_meetings {
        id
      }
      courts {
        id
      }
      transportation {
        status
      }
      primary_treatment_facilities {
        id
      }
      did_recidivate
      recidivism_reason
      case_type
      medicated
      program_result
      risk_level
      assessment_score
      hand_off_to_probation
      absconded
      is_emh
      risk_score
    }
    result
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "case_id",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "supervision_start_date",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "supervision_end_date",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "housing",
            "type": "NeedStatus",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "employment",
            "type": "NeedStatus",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "education",
            "type": "NeedStatus",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "transportation",
            "type": "NeedStatus",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "did_recidivate",
            "type": "YesNoUnknown",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "case_type",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "medicated",
            "type": "YesNoUnknown",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "program_result",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "risk_level",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "assessment_score",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "recidivism_reason",
            "type": "RecidivismReason",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "primary_treatment_facilities",
            "type": "[IdInput]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hand_off_to_probation",
            "type": "YesNoUnknown",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "treatment_types",
            "type": "[IdInput]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "courts",
            "type": "[IdInput]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "group_meetings",
            "type": "[IdInput]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "absconded",
            "type": "YesNoUnknown",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "is_emh",
            "type": "YesNoUnknown",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "risk_score",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
        } as any)
    ], v3 = [
        (v1 /*: any*/)
    ], v4 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "updateCase",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "absconded",
                    "variableName": "absconded"
                },
                {
                    "kind": "Variable",
                    "name": "assessment_score",
                    "variableName": "assessment_score"
                },
                {
                    "kind": "Variable",
                    "name": "case_id",
                    "variableName": "case_id"
                },
                {
                    "kind": "Variable",
                    "name": "case_type",
                    "variableName": "case_type"
                },
                {
                    "kind": "Variable",
                    "name": "courts",
                    "variableName": "courts"
                },
                {
                    "kind": "Variable",
                    "name": "did_recidivate",
                    "variableName": "did_recidivate"
                },
                {
                    "kind": "Variable",
                    "name": "education",
                    "variableName": "education"
                },
                {
                    "kind": "Variable",
                    "name": "employment",
                    "variableName": "employment"
                },
                {
                    "kind": "Variable",
                    "name": "group_meetings",
                    "variableName": "group_meetings"
                },
                {
                    "kind": "Variable",
                    "name": "hand_off_to_probation",
                    "variableName": "hand_off_to_probation"
                },
                {
                    "kind": "Variable",
                    "name": "housing",
                    "variableName": "housing"
                },
                {
                    "kind": "Variable",
                    "name": "is_emh",
                    "variableName": "is_emh"
                },
                {
                    "kind": "Variable",
                    "name": "medicated",
                    "variableName": "medicated"
                },
                {
                    "kind": "Variable",
                    "name": "primary_treatment_facilities",
                    "variableName": "primary_treatment_facilities"
                },
                {
                    "kind": "Variable",
                    "name": "program_result",
                    "variableName": "program_result"
                },
                {
                    "kind": "Variable",
                    "name": "recidivism_reason",
                    "variableName": "recidivism_reason"
                },
                {
                    "kind": "Variable",
                    "name": "risk_level",
                    "variableName": "risk_level"
                },
                {
                    "kind": "Variable",
                    "name": "risk_score",
                    "variableName": "risk_score"
                },
                {
                    "kind": "Variable",
                    "name": "supervision_end_date",
                    "variableName": "supervision_end_date"
                },
                {
                    "kind": "Variable",
                    "name": "supervision_start_date",
                    "variableName": "supervision_start_date"
                },
                {
                    "kind": "Variable",
                    "name": "transportation",
                    "variableName": "transportation"
                },
                {
                    "kind": "Variable",
                    "name": "treatment_types",
                    "variableName": "treatment_types"
                }
            ],
            "concreteType": "NewCaseResult",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "case",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Case",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "case_number",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "supervision_start_date",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "supervision_end_date",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "created_at",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "updated_at",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "housing",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CaseNeed",
                            "plural": false,
                            "selections": (v2 /*: any*/)
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "employment",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CaseNeed",
                            "plural": false,
                            "selections": (v2 /*: any*/)
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "education",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CaseNeed",
                            "plural": false,
                            "selections": (v2 /*: any*/)
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "treatment_types",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "IdField",
                            "plural": true,
                            "selections": (v3 /*: any*/)
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "group_meetings",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "IdField",
                            "plural": true,
                            "selections": (v3 /*: any*/)
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "courts",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "IdField",
                            "plural": true,
                            "selections": (v3 /*: any*/)
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "transportation",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CaseNeed",
                            "plural": false,
                            "selections": (v2 /*: any*/)
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "primary_treatment_facilities",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "IdField",
                            "plural": true,
                            "selections": (v3 /*: any*/)
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "did_recidivate",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "recidivism_reason",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "case_type",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "medicated",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "program_result",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "risk_level",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "assessment_score",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hand_off_to_probation",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "absconded",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "is_emh",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "risk_score",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "result",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "caseUpdateMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v4 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "caseUpdateMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v4 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "caseUpdateMutation",
            "id": null,
            "text": "mutation caseUpdateMutation(\n  $case_id: String!\n  $supervision_start_date: String\n  $supervision_end_date: String\n  $housing: NeedStatus\n  $employment: NeedStatus\n  $education: NeedStatus\n  $transportation: NeedStatus\n  $did_recidivate: YesNoUnknown\n  $case_type: String\n  $medicated: YesNoUnknown\n  $program_result: String\n  $risk_level: String\n  $assessment_score: String\n  $recidivism_reason: RecidivismReason\n  $primary_treatment_facilities: [IdInput]\n  $hand_off_to_probation: YesNoUnknown\n  $treatment_types: [IdInput]\n  $courts: [IdInput]\n  $group_meetings: [IdInput]\n  $absconded: YesNoUnknown\n  $is_emh: YesNoUnknown\n  $risk_score: String\n) {\n  updateCase(case_id: $case_id, supervision_start_date: $supervision_start_date, supervision_end_date: $supervision_end_date, housing: $housing, employment: $employment, education: $education, transportation: $transportation, did_recidivate: $did_recidivate, treatment_types: $treatment_types, case_type: $case_type, medicated: $medicated, program_result: $program_result, courts: $courts, risk_level: $risk_level, assessment_score: $assessment_score, recidivism_reason: $recidivism_reason, primary_treatment_facilities: $primary_treatment_facilities, hand_off_to_probation: $hand_off_to_probation, group_meetings: $group_meetings, absconded: $absconded, is_emh: $is_emh, risk_score: $risk_score) {\n    case {\n      id\n      case_number\n      supervision_start_date\n      supervision_end_date\n      created_at\n      updated_at\n      housing {\n        status\n      }\n      employment {\n        status\n      }\n      education {\n        status\n      }\n      treatment_types {\n        id\n      }\n      group_meetings {\n        id\n      }\n      courts {\n        id\n      }\n      transportation {\n        status\n      }\n      primary_treatment_facilities {\n        id\n      }\n      did_recidivate\n      recidivism_reason\n      case_type\n      medicated\n      program_result\n      risk_level\n      assessment_score\n      hand_off_to_probation\n      absconded\n      is_emh\n      risk_score\n    }\n    result\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'ccc5d7dadfec3a4d501c767f2a34785d';
export default node;
